export default "__VITE_ASSET__eQnFeVm8__"